import { UserPreview } from '@bizzabo/entities';

import MeetingItem from '../MeetingItem';
import { ScheduledMeeting } from '../../types';
import LocationDetails from '../LocationDetails';
import TimeInfo from '../TimeInfo';
import DateAndTime from '../DateAndTime';
import LocationBadge from '../LocationBadge';
import UserBadgeAction from '../UserBadgeAction';
import ItemDropdownMenu from '../ItemDropdownMenu';
import ItemDropdownMenuButton from '../ItemDropdownMenu/ItemDropdownMenuButton';
import { useMeetings } from '../../MeetingsTool/MeetingsToolContext';

interface HistoryItemProps {
    meeting: ScheduledMeeting;
    user: UserPreview;
}

const HistoryItem: React.FC<HistoryItemProps> = ({ meeting, user }) => {
    const { openWizard } = useMeetings();

    return (
        <MeetingItem>
            <TimeInfo isDisabled>
                <DateAndTime startDate={meeting.startDate} endDate={meeting.endDate} />
                <LocationBadge locationType={meeting.locationType} />
            </TimeInfo>
            <UserBadgeAction
                user={user}
                hasNotification={!!meeting.notifications?.length}
                isDisabled
            >
                <ItemDropdownMenu>
                    {(closeDropdown: () => void) => (
                        <ItemDropdownMenuButton
                            onClick={() => {
                                closeDropdown();
                                openWizard({ otherAttendeeId: user.userProfileId });
                            }}
                        >
                            Schedule Meeting
                        </ItemDropdownMenuButton>
                    )}
                </ItemDropdownMenu>
            </UserBadgeAction>
            <LocationDetails physicalLocation={meeting.physicalLocation} isDisabled />
        </MeetingItem>
    );
};

export default HistoryItem;
